import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../components/App/AppAuth'
import { useTenantContext } from '../components/App/AppTenant'
import EqxButton from '../shared/components/EqxButton/EqxButton'

interface PageLoginProps { }
const PageLogin = function (props: PageLoginProps) {
    const auth = useAuthContext()
    const navigate = useNavigate()
    const tenant = useTenantContext()
    const [error, setError] = React.useState<string | null>(null)

    const tenantName = tenant.name

    useEffect(() => {
        //change body class - remove any that start with page-* and add page-login
        document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        document.body.classList.add('page-login')

        return () => {
            document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        }
    }, [])

    const onLoginClick = () => {
        if (!auth) throw Error('No auth context provided')
        return auth
            .login()
            .then(function () {
                setError(null)
                navigate('/')
            })
            .catch(function (errorMessage) {
                console.error(errorMessage)
                setError('Sorry, an error occurred while trying to log in, please contact support.')
            })
    }
    return (
        <div id="login-container">
            <div id="login-outer-title">Continuum-BI - {tenantName}</div>
            <div id="login">
                <div id="login-header">
                    <img src="/images/logo-no-text.svg" alt="Continuum-BI" id="login-logo" />
                    <img src="/images/logo-text.svg" alt="" id="login-logo-text" style={{ height: 20 }} />
                </div>
                <div id="login-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <EqxButton onClick={onLoginClick} size="lg" variant="primary" id="login-button">
                        <span className="fab fa-windows me-2"></span>
                        Login
                    </EqxButton>
                </div>
            </div>
        </div>
    )
}
export default PageLogin
